import React, { useEffect, useState } from 'react'
import { useSwipeable } from "react-swipeable";
import '../../Styles/App.css';

import {
  faArrowRightArrowLeft,
  faChevronLeft,
  faChevronRight,
  faClock,
  faClockRotateLeft,
  faMagnifyingGlass,
  faArrowRight
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Section6({ hours = 1, minutes = 30, seconds = 0 }) {
  const [isSwipedRight, setIsSwipedRight] = useState(false);

  const handleSwipeRight = () => setIsSwipedRight(true);
  const handleSwipeLeft = () => setIsSwipedRight(false);

  const handlers = useSwipeable({
    onSwipedRight: handleSwipeRight,
    onSwipedLeft: handleSwipeLeft,
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  const [time, setTime] = useState({ hours, minutes, seconds, });

  useEffect(() => {
    const timer = setInterval(() => {
      setTime((prevTime) => {
        let { hours, minutes, seconds } = prevTime;

        if (seconds > 0) {
          seconds -= 1;
        } else {
          if (minutes > 0) {
            minutes -= 1;
            seconds = 59;
          } else if (hours > 0) {
            hours -= 1;
            minutes = 59;
            seconds = 59;
          } else {
            clearInterval(timer);
          }
        }

        return { hours, minutes, seconds };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className='min-h-screen py-10 bg-[#0E081B]/30'>
      <div className='w-[90%] mx-auto py-10 relative'>
        <div className='w-[100%] lg:w-[40%] mr-auto overflow-hidden lg:absolute' style={{ zIndex: 1 }}>
          <h1 className='text-white font-bold  text-2xl lg:text-4xl 2xl:text-5xl text-left'>MARKETPLACE</h1>
          <p className='text-white mt-3'>Take the shot in finding your next star! Browse through GoalDex verified player passports, packed with football prowess and scientific insights. From performance metrics to genetic profiles, discover everything you need here.</p>
          <button className='py-2 px-10 mt-5 cursor-pointer rounded-md font-bold bg-gradient-to-r from-[#2F1073] via-[#5C1FE2] to-[#2F1073]'>
            Explore
          </button>
          {/*
          <div
            {...handlers}
            className="bg-transparent border-2 border-white rounded-full w-[75%] lg:w-[50%] mt-3"
          >
            <div
              className={`relative ${isSwipedRight
                ? "bg-green-500"
                : "bg-transparent"
                } rounded-full py-1 flex justify-center items-center`}
            >
              <div
                className={`w-[100%] mx-auto absolute left- transition-transform duration-500 ${isSwipedRight ? "md:translate-x-[82%] translate-x-[82%]" : "translate-x-0"
                  }`}
              >
                <div
                  className="w-10 h-10 cursor-pointer rounded-full bg-white flex justify-center items-center"
                >
                  <FontAwesomeIcon icon={faChevronRight} className="" style={{ color: "#856E4F" }} />
                  <FontAwesomeIcon icon={faChevronRight} className="-translate-x-1" style={{ color: "#856E4F" }} />
                </div>
              </div>
              <div className="w-[90%] mt-1">
                <p className="font-Artemus text-lg text-center font-bold">Expore</p>
              </div>
            </div>
          </div>*/}
        </div>
        <div className='flex flex-col lg:flex-row gap-5 w-[100%] mx-auto '>
          <div className='w-[100%] lg:w-[50%] grid content-end pt-5 lg:pt-0 lg:pb-10 2xl:pb-20 relative'>
            <div className='flex flex-col lg:flex-row gap-5 items-center justify-end'>
              <div className='Marketplace-aution -skew-x-12 lg:-translate-y-10 border border-white/10 py-2 px-5 2xl:px-7 2xl:py-4 rounded-xl bg-gradient-to-b from-[#0e0b14] to-[#1d1a24]'>
                <h1 className='font-bold text-lg'>Auction</h1>
                <p className='text-[#24FF00] text-sm'>Ends In <i className='fa-solid fa-arrow-right-long text-white ml-1'></i></p>
              </div>
              <div
                className='-skew-x-12 text-center flex gap-7 border border-white/10 py-4 px-10 2xl:py-6 rounded-2xl bg-gradient-to-b from-[#0e0b14] to-[#1d1a24]'
                style={{ filter: 'drop-shadow(0px 0px 10px #2F1073)' }}>
                <div className='sm:w-16'>
                  <span className='text-3xl font-bold'>{String(time.hours).padStart(2, "0")} :</span>
                  <p>Hours</p>
                </div>
                <div className='sm:w-16'>
                  <span className='text-3xl font-bold'>{String(time.minutes).padStart(2, "0")} :</span>
                  <p>Minutes</p>
                </div>
                <div className='sm:w-16'>
                  <span className='text-3xl font-bold'>{String(time.seconds).padStart(2, "0")} </span>
                  <p>Seconds</p>
                </div>
              </div>
              <div className='absolute hidden lg:block translate-x-40 2xl:translate-x-52'>
                <div className='flex items-center'>
                  <div className='h-[6px] w-[6px] bg-white rotate-45'></div>
                  <div className='w-40 2xl:w-52 border-t-2 border-dashed'></div>
                </div>
              </div>
            </div>
          </div>
          <div className='w-[100%] lg:w-[50%] relative flex flex-col-reverse gap-5'>
            <div className='Ether-icon hidden lg:block absolute top-[50%] -translate-y-[50%] left-[10%] 2xl:left-[15%]' style={{ zIndex: 1 }}>
              <div className='p-1 rounded-full overflow-hidden relative'>
                <div className='icon-gradient animate-spin-slow'></div>
                <div className='bg-black rounded-full grid place-content-center '>
                  <div className='w-[120px] h-[120px] rounded-full grid place-content-center bg-gradient-to-b from-white/50 to-black/50'>
                    <img src='/assets/others/Etherium.svg' className='w-14 '></img>
                  </div>
                </div>
              </div>
            </div>
            <div className='w-[100%] md:w-[55%] mx-auto rounded-3xl p-5 border border-white/10 bg-gradient-to-b from-[#0e0c15] via-[#120d20] to-[#141633] relative'>
              <img src='/assets/others/sec7_right.svg' className='w-[75%] mx-auto'></img>
              <button className='w-full py-2 2xl:py-3 cursor-pointer rounded-md font-bold bg-gradient-to-r from-[#2F1073] via-[#5C1FE2] to-[#2F1073]'>
                BID NFT
              </button>
            </div>
            <div className='Marketplace-Bid lg:absolute w-[100%] md:w-[50%] mx-auto lg:mx-0 lg:w-[225px] 2xl:w-[250px] top-[15%] right-0 border p-5 lg:p-3 2xl:p-5 backdrop-blur-md bg-white/5 rounded-2xl flex items-center gap-5'>
              <div className='w-[50%]'>
                <h1 className='font-bold text-lg truncate'>SCO777_NFT</h1>
                <p className='font-bold lg:text-sm 2xl:text-lg truncate'>Current Bid</p>
              </div>
              <div className='w-[50%]'>
                <h1 className='font-extrabold flex justify-end gap-1 items-center text-end text-lg lg:text-base 2xl:text-lg truncate'><img src='/assets/icon/ether.svg'></img>1038.52</h1>
                <p className='text-[#00FF0D] text-end font-bold lg:text-sm 2xl:text-lg truncate'>+ 20.81%</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

